// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__xWCxU","text":"SelectPayment_text__353bt","title":"SelectPayment_title__1fE-a","btn":"SelectPayment_btn__89qCp"};